import { useState, useEffect, useCallback } from "react";
import { getOrgLocationLevels, getOrgLocationMaster } from "../../../../Api/RbacAdminApi";
import CODE from "../../../../Static/Constants/StatusCodes";

const useOrgLocations = () => {
  const [locationLevels, setLocationLevels] = useState([]);
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchLevels = useCallback(async () => {
    const res = await getOrgLocationLevels();
    if (res?.responseStatus?.code === CODE.SUCCESS) {
      const active = (res.response?.data || [])
        .filter((l) => l.isActive)
        .sort((a, b) => a.level.localeCompare(b.level));
      setLocationLevels(active);
    }
  }, []);

  const fetchLocations = useCallback(async (filterParams = {}) => {
    setIsLoading(true);
    try {
      const params = {};
      Object.keys(filterParams).forEach((key) => {
        const val = filterParams[key];
        if (Array.isArray(val) && val.length > 0) params[key] = val[0];
        else if (val && !Array.isArray(val)) params[key] = val;
      });
      const res = await getOrgLocationMaster(Object.keys(params).length ? params : undefined);
      if (res?.responseStatus?.code === CODE.SUCCESS) {
        setLocations(res.response?.data || []);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLevels();
    fetchLocations();
  }, [fetchLevels, fetchLocations]);

  return { locationLevels, locations, isLoading, refetch: fetchLocations };
};

export default useOrgLocations;
